<template>
  <div>
    <Login_phone v-if="phone_see"> </Login_phone>
    <Login_sms v-if="sms"> </Login_sms>
  </div>
</template>

<script>
import Login_phone from './Login_phone';
import Login_sms from './Login_sms';

let CCMT;

export default{
  components: {Login_phone, Login_sms},
  data() {
    return {
      code: '',
      phone_see: true,
      sms: false,
      phone: "",
      password: "",
      checkbox_remember_me: false,
    }
  },
  computed: {
    CCMT () {
      return CCMT;
    },
    validateForm() {
      return CCMT.phone !== '' && CCMT.password.length >= 0;
    },
  },
  methods: {
  },
  mounted() {
    if (window.notification){
      clearTimeout(window.notification)
    }
  },
  async created() {
    window.LoginCCMT = this;
    CCMT = this;
  }
}
</script>